import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { initiateUpdateComponent } from '../../../../state/actions.tsx';
import { getName } from '../../../../state/components/selectors.tsx';
import type { State } from '../../../../state/reducer.tsx';
import { deleteComponentStarted } from '../../../../state/ui/delete/actions.tsx';
import { showSpinner } from './selectors.tsx';
import ActionsView from './view.tsx';

type Props = {
	componentId: string;
};

const mapStateToProps = (state: State, ownProps: Props) => ({
	showSpinner: showSpinner(state, ownProps.componentId),
	name: getName(state, ownProps.componentId),
});

const mapDispatchToProps = (dispatch: Dispatch, ownProps: Props) => ({
	onEdit: () => dispatch(initiateUpdateComponent({ id: ownProps.componentId })),
	onDelete: () => dispatch(deleteComponentStarted({ id: ownProps.componentId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionsView);
